import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, take } from 'rxjs/operators';
import { LocalizationService } from 'src/core/utilitites/localization.service';

import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-impersonate',
    templateUrl: './impersonate.component.html',
    styleUrls: ['./impersonate.component.scss'],
    standalone: false
})
export class ImpersonateComponent implements OnInit {
    constructor(
        private router: Router,
        private localization: LocalizationService,
        private activatedRoute: ActivatedRoute,
        private msalBroadcastService: MsalBroadcastService
    ) {}

    ngOnInit() {
        // Clear stale MSAL interaction status from a previous impersonation session.
        sessionStorage.removeItem('msal.interaction.status');
        
        this.msalBroadcastService.inProgress$.pipe(
            filter((status: InteractionStatus) => status === InteractionStatus.None),
            take(1)
        ).subscribe(() => {
            window.sessionStorage.clear();
            if (window.location.hash.includes('error') || window.location.search.includes('error')) {
                window.location.href = environment.logoutRedirectURI;
            } else {
                this.router.navigateByUrl('/base#imp-success');
            }
        });
    }

    translate(key) {
        return this.localization.generateLocalizedStr(key);
    }
}
